export enum ModalButtonsStateEnum {
  OK = 'OK',
  CANCEL = 'CANCEL',
  YES = 'YES',
  NO = 'NO',
  CLOSE = 'CLOSE',
}
